import React from "react";
import HReusableAlertModal from "./HReusableAlertModal";

const HLogoutModal = ({ show, onClose, onConfirm, isLoading }) => {
  return (
    <HReusableAlertModal
      isOpen={show}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Sign Out"
      description="Are you sure you want to sign out? You'll need to sign in again to access your account."
      confirmLabel="Sign Out"
      loadingLabel="Signing out..."
      isLoading={isLoading}
    />
  );
};

export default HLogoutModal;
